module.exports = __webpack_public_path__ + "static/media/forthing.eb5d5f43.png";